"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigContext = exports.DEFAULT_LOCALE = exports.DEFAULT_CLASS_PREFIX = void 0;
/* eslint-disable @typescript-eslint/camelcase */
var react_1 = require("react");
// 支持 webpack 注入
exports.DEFAULT_CLASS_PREFIX = typeof TEA_CLASS_PREFIX !== "undefined" ? TEA_CLASS_PREFIX : "tea";
exports.DEFAULT_LOCALE = typeof WEBPACK_BUILD_LOCALE !== "undefined" ? WEBPACK_BUILD_LOCALE : "zh";
exports.ConfigContext = react_1.createContext({
    classPrefix: exports.DEFAULT_CLASS_PREFIX,
    locale: exports.DEFAULT_LOCALE,
});
//# sourceMappingURL=ConfigContext.js.map